module.exports = "/images/ReviewVertical_B.png?8777d7068bc6e3460af38fbc86029af2";